module.exports = __webpack_public_path__ + "media/images/iconSettings__errorRed-12d5067071d88c872afe35e65bab2fdc.png";